<template>
  <div class="relatorio-container mt-3">

    <!-- Cabeçalho -->
    <div class="card relatorio-card mb-4">
      <div class="relatorio-card-header d-flex justify-content-between align-items-center">
        <h3 class="mb-0">Relatório de Boletos</h3>
        <button class="btn-voltar" @click="$router.go(-1)">Voltar</button>
      </div>
    </div>

    <!-- Filtros -->
    <div class="card relatorio-card mb-4">
      <div class="relatorio-card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Filtros</h5>

        <!-- Abas: boletos já criados x projeção do mês vigente -->
        <div class="abas-resultado">
          <button
            type="button"
            class="aba-btn"
            :class="{ ativa: aba === 'boletos' }"
            @click="trocarAba('boletos')"
          >Boletos</button>
          <button
            type="button"
            class="aba-btn"
            :class="{ ativa: aba === 'projecoes' }"
            @click="trocarAba('projecoes')"
          >Projeções</button>
        </div>
      </div>
      <div class="relatorio-card-body">
        <div class="row g-2">
          <div class="col-md" v-if="aba === 'boletos'">
            <label>Data início</label>
            <input type="date" v-model="filtros.data_inicio" class="form-control">
          </div>

          <div class="col-md" v-if="aba === 'boletos'">
            <label>Data fim</label>
            <input type="date" v-model="filtros.data_fim" class="form-control">
          </div>

          <div class="col-md">
            <label>Pasta</label>
            <input type="text" v-model="filtros.pasta" class="form-control">
          </div>

          <div class="col-md">
            <label>Referência</label>
            <input type="text" v-model="filtros.referencia" class="form-control">
          </div>

          <div class="col-md" v-if="aba === 'boletos'">
            <label>Status</label>
            <select v-model="filtros.pago" class="form-control">
              <option value="">Todos</option>
              <option value="1">Pago</option>
              <option value="0">Em aberto</option>
            </select>
          </div>

          <div class="col-md" v-if="aba === 'boletos'">
            <label>Enviado</label>
            <select v-model="filtros.enviado" class="form-control">
              <option value="">Todos</option>
              <option value="1">Sim</option>
              <option value="0">Não</option>
            </select>
          </div>

          <div class="col-md d-flex align-items-end">
            <button class="btn-buscar w-100" @click="buscar">
              Buscar
            </button>
          </div>
        </div>

        <!-- Atalhos de vencimento.
             Aba Boletos: define a faixa de datas do mês (data_inicio/data_fim).
             Aba Projeções: filtra os contratos pelo dia de vencimento (LOC_VENCIMENTO). -->
        <div class="filtro-vencimento mt-4">
          <p class="filtro-label">
            Vencimentos{{ aba === 'projecoes' ? ' (dia do contrato)' : '' }}:
          </p>
          <div class="d-flex flex-wrap">
            <button
              type="button"
              @click="filtrarVencimento(10)"
              :class="['btn-filtro-pill', 'pill-info', 'mr-1', { 'pill-ativo': pillAtiva === 10 }]"
            >Até dia 10</button>

            <button
              type="button"
              @click="filtrarVencimento(20)"
              :class="['btn-filtro-pill', 'pill-warning', 'mr-1', { 'pill-ativo': pillAtiva === 20 }]"
            >Dia 11 - 20</button>

            <button
              type="button"
              @click="filtrarVencimento(30)"
              :class="['btn-filtro-pill', 'pill-success', 'mr-1', { 'pill-ativo': pillAtiva === 30 }]"
            >Dia 21 - 30</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Resultados -->
    <div class="card relatorio-card mb-4">
      <div class="relatorio-card-header">
        <h5 class="mb-0">{{ tituloResultados }}</h5>
      </div>
      <div class="relatorio-card-body">

        <!-- ===== Aba Boletos: boletos já criados ===== -->
        <template v-if="aba === 'boletos'">
        <div class="table-responsive">
          <table class="table table-docs text-center align-middle mb-0">
            <thead>
              <tr>
                <th>Pasta</th>
                <th>Referência</th>
                <th>Locador</th>
                <th>Locatário</th>
                <th>Vencimento</th>
                <th>Valor Total</th>
                <th>Pago?</th>
                <th>Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="boletos.length === 0">
                <td colspan="8" class="text-muted py-4">Nenhum boleto encontrado.</td>
              </tr>

              <tr v-for="b in boletos" :key="b.id" :class="{ 'linha-rascunho': b.enviado != 1 && b.pago != 1 }">
                <td>{{ b.pasta }}</td>
                <td>{{ b.referencia }}</td>
                <td>{{ b.locador }}</td>
                <td>{{ b.locatario }}</td>
                <td>{{ formatarData(b.vencimento) }}</td>
                <td class="valor-cell">{{ formatarMoeda(b.valor_total) }}</td>
                <td>
                  <span v-if="b.pago == 1" class="badge-status pago-sim">Pago</span>
                  <span v-else-if="b.enviado == 1" class="badge-status enviado-badge">Enviado</span>
                  <span v-else class="badge-status rascunho-badge">Rascunho</span>
                </td>
                <td>
                  <router-link
                    :to="`/edicaoBoleto/${b.pasta}/${b.id}`"
                    class="btn-visualizar"
                  >
                    Visualizar
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginação -->
        <nav class="mt-3">
          <ul class="pagination justify-content-center mb-0">
            <li class="page-item" :class="{ disabled: page === 1 }">
              <button class="page-link" @click="page-- && carregar()">«</button>
            </li>

            <li class="page-item disabled">
              <span class="page-link">
                Página {{ page }} de {{ totalPages }}
              </span>
            </li>

            <li class="page-item" :class="{ disabled: page === totalPages }">
              <button class="page-link" @click="page++ && carregar()">»</button>
            </li>
          </ul>
        </nav>
        </template>

        <!-- ===== Aba Projeções: contratos que ainda não têm boleto no mês vigente ===== -->
        <template v-else>
          <!-- Resumo do mês projetado -->
          <div class="projecao-resumo mb-3" v-if="!erroProjecoes">
            <span class="projecao-resumo-item">
              <strong>Mês vigente:</strong> {{ mesProjecaoFormatado }}
            </span>
            <span class="projecao-resumo-item">
              <strong>{{ projecoesVisiveis.length }}</strong> contrato(s) sem boleto
            </span>
            <span class="projecao-resumo-item">
              <strong>Total estimado:</strong> {{ formatarMoeda(totalProjecao) }}
            </span>
          </div>

          <div class="table-responsive">
            <table class="table table-docs text-center align-middle mb-0">
              <thead>
                <tr>
                  <th>Pasta</th>
                  <th>Referência</th>
                  <th>Locador</th>
                  <th>Locatário</th>
                  <th>Dia venc.</th>
                  <th>Valor estimado</th>
                  <th>Situação</th>
                  <th>Ações</th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="carregandoProjecoes">
                  <td colspan="8" class="text-center py-4">
                    <div class="spinner-border text-muted" role="status" style="max-height:40px;">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </td>
                </tr>

                <tr v-else-if="projecoesVisiveis.length === 0">
                  <td colspan="8" class="text-muted py-4">
                    {{ erroProjecoes
                      ? 'Não foi possível carregar a projeção. Tente novamente.'
                      : 'Todos os contratos filtrados já possuem boleto no mês vigente.' }}
                  </td>
                </tr>

                <tr v-for="p in projecoesExibidas" :key="p.LOC_PASTA">
                  <td>{{ p.LOC_PASTA }}</td>
                  <td>{{ p.LOC_IMOVEL }}</td>
                  <td>{{ p.LOC_LOCADOR }}</td>
                  <td>{{ p.LOC_LOCATARIO }}</td>
                  <td>Dia {{ p.LOC_VENCIMENTO || '-' }}</td>
                  <td class="valor-cell">{{ formatarMoeda(valorEstimado(p)) }}</td>
                  <td>
                    <span class="badge-status rascunho-badge">Não criado</span>
                  </td>
                  <td>
                    <router-link :to="`/boletos/${p.LOC_PASTA}`" class="btn-visualizar">
                      Criar
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="text-center mt-3" v-if="projecoesExibidas.length < projecoesVisiveis.length">
            <button type="button" class="btn-carregar-mais" @click="limiteProjecoes += 50">
              Mostrar mais
            </button>
          </div>
        </template>
      </div>
    </div>
    <!-- Botão de acesso rápido - Buscar Locações -->
    <router-link to="/buscaLocacoes" class="fab-buscar-locacoes" title="Buscar Locações">
      <span class="fab-icone">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </svg>
      </span>
      <span class="fab-texto">Buscar Locações</span>
    </router-link>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "RelatorioBoletos",
data() {
  return {
    boletos: [],
    filtros: {
      pasta: '',
      referencia: '',
      pago: '',
      enviado: '',
      data_inicio: '',
      data_fim: ''
    },
    page: 1,
    limit: 10,
    total: 0,
    // Aba ativa: 'boletos' (já criados) ou 'projecoes' (mês vigente sem boleto)
    aba: 'boletos',
    // Faixa de vencimento ativa (10, 20 ou 30) - usada para destacar o botão
    faixaAtiva: null,
    // Dia de vencimento do contrato filtrado na aba de projeções
    filtroDia: null,
    // Dados da projeção do mês vigente
    projecoes: [],
    mesProjecao: '',
    carregandoProjecoes: false,
    erroProjecoes: false,
    limiteProjecoes: 50
  }
},
computed: {
  totalPages() {
    return Math.ceil(this.total / this.limit) || 1;
  },
  // Destaque do atalho: depende da aba ativa
  pillAtiva() {
    return this.aba === 'boletos' ? this.faixaAtiva : this.filtroDia;
  },
  // Título do card de resultados conforme a aba
  tituloResultados() {
    return this.aba === 'boletos'
      ? 'Resultados'
      : 'Projeção - boletos do mês não criados';
  },
  // Mês da projeção formatado como MM/AAAA
  mesProjecaoFormatado() {
    if (!this.mesProjecao) return '-';
    const partes = this.mesProjecao.split('-');
    return partes[1] + '/' + partes[0];
  },
  // Contratos que estão vigentes dentro do mês vigente
  projecoesVisiveis() {
    return this.projecoes.filter(p => this.contratoVigenteNoMes(p));
  },
  // Fatia exibida na tabela (controle de "Mostrar mais")
  projecoesExibidas() {
    return this.projecoesVisiveis.slice(0, this.limiteProjecoes);
  },
  // Soma dos valores estimados dos contratos listados
  totalProjecao() {
    return this.projecoesVisiveis.reduce((soma, p) => soma + this.valorEstimado(p), 0);
  }
},
methods: {
  carregar() {
    const params = {
      ...this.filtros,
      page: this.page,
      limit: this.limit
    };

    axios.get(
      'https://www2.royaljardim.com.br/sistema/Boletos/relatorio_filtrado',
      { params }
    ).then(res => {
      this.boletos = res.data.dados;
      this.total = res.data.total;
    });
  },
  buscar() {
    this.page = 1;

    // Aba Projeções: recarrega a lista de contratos sem boleto no mês
    if (this.aba === 'projecoes') {
      this.carregarProjecoes();
      return;
    }

    // Aba Boletos: busca manual remove o destaque do atalho de vencimento
    this.faixaAtiva = null;
    this.carregar();
  },
  // Troca a aba (Boletos x Projeções) e carrega o conteúdo correspondente
  trocarAba(nova) {
    if (this.aba === nova) return;
    this.aba = nova;
    this.page = 1;
    if (nova === 'projecoes') {
      this.carregarProjecoes();
    }
  },
  // Busca os contratos que ainda não têm boleto no mês vigente
  carregarProjecoes() {
    this.carregandoProjecoes = true;
    this.erroProjecoes = false;
    this.limiteProjecoes = 50;

    axios.get(
      'https://www2.royaljardim.com.br/sistema/Boletos/projecoes',
      {
        params: {
          pasta: this.filtros.pasta,
          referencia: this.filtros.referencia,
          vencimento: this.filtroDia || ''
        }
      }
    ).then(res => {
      this.projecoes = (res.data && res.data.dados) || [];
      this.mesProjecao = (res.data && res.data.mes) || '';
    }).catch(err => {
      console.log(err);
      this.erroProjecoes = true;
      this.projecoes = [];
    }).finally(() => this.carregandoProjecoes = false);
  },
  // O contrato está vigente dentro do mês vigente?
  // Fim do contrato = base (renovação ou início) + LOC_TEMPO_CONTRATO meses,
  // mesmo critério usado na projeção de Relatorios.vue.
  contratoVigenteNoMes(p) {
    const base = p.LOC_RENOVACAOCONTRATO || p.LOC_INICIO_CONTRATO;
    const tempo = parseInt(p.LOC_TEMPO_CONTRATO, 10);

    const hoje = new Date();
    const inicioMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    const fimMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

    // Sem tempo de contrato definido: considera o contrato em andamento
    if (!base || !tempo) return true;

    // 'T00:00:00' força o parse na hora local (evita deslocamento de fuso)
    const baseDt = new Date(base + 'T00:00:00');
    if (isNaN(baseDt)) return true;

    const fim = new Date(baseDt);
    fim.setMonth(fim.getMonth() + tempo);

    if (fim < inicioMes) return false;  // encerrado antes do mês vigente
    if (baseDt > fimMes) return false;  // começa depois do mês vigente
    return true;
  },
  // Valor estimado do boleto do mês: aluguel + taxa + IPTU/seguro
  // enquanto houver parcelas abertas (mesma composição de Relatorios.vue)
  valorEstimado(p) {
    const aluguel = parseFloat(p.LOC_ALUGUEL) || 0;
    const taxa = parseFloat(p.LOC_BOLETO) || 0;
    const iptu = (parseInt(p.LOC_IPTU_PARCELAS_ABERTAS, 10) > 0)
      ? (parseFloat(p.LOC_IPTU_VALOR) || 0) : 0;
    const seguro = (parseInt(p.LOC_SEGURO_PARCELAS_ABERTAS, 10) > 0)
      ? (parseFloat(p.LOC_SEGURO_VALOR) || 0) : 0;
    return aluguel + taxa + iptu + seguro;
  },
  // Converte Date para YYYY-MM-DD usando a data local (sem deslocamento de fuso)
  formatarISO(data) {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  },
  // Atalhos de vencimento.
  // Aba Boletos: preenche data_inicio/data_fim com a faixa no mês atual.
  // Aba Projeções: filtra os contratos pelo dia de vencimento (LOC_VENCIMENTO).
  filtrarVencimento(faixa) {
    // Projeções: clicar de novo no mesmo atalho limpa o filtro do dia
    if (this.aba === 'projecoes') {
      this.filtroDia = (this.filtroDia === faixa) ? null : faixa;
      this.carregarProjecoes();
      return;
    }

    // Clicar de novo no mesmo atalho limpa a faixa e volta para a busca completa
    if (this.faixaAtiva === faixa) {
      this.faixaAtiva = null;
      this.filtros.data_inicio = '';
      this.filtros.data_fim = '';
      this.page = 1;
      this.carregar();
      return;
    }

    const hoje = new Date();
    const ano = hoje.getFullYear();
    const mes = hoje.getMonth();
    const ultimoDiaDoMes = new Date(ano, mes + 1, 0).getDate();

    let diaInicio = 1;
    let diaFim = 10;

    if (faixa === 20) {
      diaInicio = 11;
      diaFim = 20;
    } else if (faixa === 30) {
      diaInicio = 21;
      diaFim = ultimoDiaDoMes;
    }

    this.filtros.data_inicio = this.formatarISO(new Date(ano, mes, diaInicio));
    this.filtros.data_fim = this.formatarISO(new Date(ano, mes, diaFim));
    this.faixaAtiva = faixa;

    this.page = 1;
    this.carregar();
  },
  formatarData(data) {
    if (!data) return '';
    return new Date(data).toLocaleDateString('pt-BR');
  },
  formatarMoeda(valor) {
    return Number(valor).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }
},
mounted() {
  this.carregar();
}
};
</script>

<style scoped>
/* ===== Container ===== */
.relatorio-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* ===== Cards ===== */
.relatorio-card {
  border: 1px solid #e8e4e3;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  overflow: hidden;
}
.relatorio-card-header {
  background: #4C1C17;
  color: #fff;
  padding: 12px 20px;
}
.relatorio-card-header h3,
.relatorio-card-header h5 {
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.relatorio-card-header h3 { font-size: 17px; }
.relatorio-card-header h5 { font-size: 14px; }
.relatorio-card-body {
  padding: 20px;
  background: #fff;
}

/* ===== Labels e Inputs ===== */
.relatorio-card label {
  color: #4C1C17;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 5px;
}
.relatorio-card .form-control {
  border-radius: 6px;
  border: 1px solid #ddd;
  padding: 9px 12px;
  font-size: 14px;
  transition: all 0.2s;
}
.relatorio-card .form-control:focus {
  border-color: #4C1C17;
  box-shadow: 0 0 0 3px rgba(76,28,23,0.1);
}

/* ===== Botões ===== */
.btn-voltar {
  background: rgba(255,255,255,0.15);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.4);
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}
.btn-voltar:hover {
  background: rgba(255,255,255,0.25);
  color: #fff;
  border-color: rgba(255,255,255,0.6);
  transform: translateY(-1px);
}

.btn-buscar {
  background: linear-gradient(135deg, #4C1C17, #6b2a22);
  color: #fff;
  border: none;
  padding: 10px 0;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 6px;
  transition: all 0.2s;
  box-shadow: 0 3px 10px rgba(76,28,23,0.3);
}
.btn-buscar:hover {
  background: linear-gradient(135deg, #6b2a22, #8a3530);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 5px 16px rgba(76,28,23,0.4);
}

/* ===== Filtro Vencimento (atalhos) ===== */
.filtro-label {
  color: #4C1C17;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.btn-filtro-pill {
  display: inline-block;
  padding: 8px 22px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  border: none;
  transition: all 0.2s;
  text-decoration: none;
}
.btn-filtro-pill:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
  color: #fff;
  text-decoration: none;
}
.pill-info {
  background: #e3f2fd;
  color: #0d6efd;
  border: 1px solid rgba(13,110,253,0.2);
}
.pill-info:hover { background: #0d6efd; color: #fff; }
.pill-warning {
  background: #fff8e1;
  color: #b8860b;
  border: 1px solid rgba(212,160,23,0.3);
}
.pill-warning:hover { background: #d4a017; color: #fff; }
.pill-success {
  background: #e8f5e9;
  color: #28a745;
  border: 1px solid rgba(40,167,69,0.25);
}
.pill-success:hover { background: #28a745; color: #fff; }
/* Destaque do atalho atualmente ativo */
.pill-ativo {
  box-shadow: 0 4px 10px rgba(0,0,0,0.18), 0 0 0 3px rgba(76,28,23,0.3);
  transform: translateY(-2px);
}

/* ===== Abas (Boletos x Projeções) ===== */
.abas-resultado {
  display: flex;
  gap: 6px;
}
.aba-btn {
  background: rgba(255,255,255,0.15);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.35);
  padding: 6px 18px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s;
}
.aba-btn:hover {
  background: rgba(255,255,255,0.28);
  color: #fff;
}
.aba-btn.ativa {
  background: #fff;
  color: #4C1C17;
  border-color: #fff;
}

/* ===== Resumo da projeção ===== */
.projecao-resumo {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  background: #f8f4f3;
  border: 1px solid #e8e4e3;
  border-left: 3px solid #4C1C17;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 13px;
  color: #4C1C17;
}
.projecao-resumo-item strong {
  font-weight: 700;
}

/* ===== Botão "Mostrar mais" (projeções) ===== */
.btn-carregar-mais {
  background: linear-gradient(135deg, #d4a017, #b8860b);
  color: #fff;
  border: none;
  padding: 10px 40px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 8px;
  transition: all 0.2s;
  box-shadow: 0 3px 10px rgba(212,160,23,0.3);
}
.btn-carregar-mais:hover {
  background: linear-gradient(135deg, #e6b422, #d4a017);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 5px 16px rgba(212,160,23,0.4);
}

.btn-visualizar {
  display: inline-block;
  background: linear-gradient(135deg, #0d6efd, #0b5ed7);
  color: #fff;
  border: none;
  padding: 7px 18px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  border-radius: 6px;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(13,110,253,0.3);
  text-decoration: none;
}
.btn-visualizar:hover {
  background: linear-gradient(135deg, #3184fd, #0d6efd);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(13,110,253,0.4);
  text-decoration: none;
}

/* ===== Badge Status ===== */
.badge-status {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.pago-sim {
  background: #e8f5e9;
  color: #28a745;
}
.pago-nao {
  background: #ffe5e5;
  color: #dc3545;
}
.enviado-badge {
  background: #e8f5e9;
  color: #28a745;
}
.rascunho-badge {
  background: #fff8e1;
  color: #92400e;
}
.linha-rascunho {
  border-left: 3px solid #f59e0b;
  background-color: #fffdf5;
}

/* ===== Tabela ===== */
.table-docs thead {
  background: #4C1C17;
  color: #fff;
}
.table-docs th {
  padding: 12px 16px;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: none;
}
.table-docs td {
  padding: 12px 16px;
  vertical-align: middle;
  font-size: 14px;
}
.table-docs tbody tr:hover {
  background: #f8f4f3;
}
.table-docs tbody tr:last-child td {
  border-bottom: none;
}
.valor-cell {
  font-weight: 700;
  color: #4C1C17;
}

/* ===== Paginação ===== */
.pagination .page-link {
  border-radius: 6px;
  margin: 0 3px;
  border: 1px solid #ddd;
  color: #4C1C17;
  transition: all 0.2s;
}
.pagination .page-link:hover {
  background: #4C1C17;
  color: #fff;
  border-color: #4C1C17;
}
.pagination .page-item.disabled .page-link {
  background: #f8f6f5;
  color: #999;
}

/* ===== FAB Buscar Locações ===== */
.fab-buscar-locacoes {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #4C1C17, #6b2a22);
  color: #fff;
  padding: 14px 22px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  box-shadow: 0 6px 20px rgba(76,28,23,0.4);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fab-icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
}
.fab-icone svg {
  width: 24px;
  height: 24px;
}
.fab-texto {
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  opacity: 0;
  transition: all 0.3s ease;
}
.fab-buscar-locacoes:hover {
  background: linear-gradient(135deg, #6b2a22, #8a3530);
  transform: translateY(-3px);
  box-shadow: 0 10px 28px rgba(76,28,23,0.5);
}
.fab-buscar-locacoes:hover .fab-texto {
  max-width: 140px;
  opacity: 1;
}
.fab-buscar-locacoes::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50px;
  border: 2px solid #4C1C17;
  animation: fabPulse 2s infinite;
}
@keyframes fabPulse {
  0%   { transform: scale(1);   opacity: 0.8; }
  70%  { transform: scale(1.12); opacity: 0; }
  100% { transform: scale(1.12); opacity: 0; }
}
</style>